export default {
  signInWithGoogle: "使用 Google 登录",
  signInWithTwitter: "使用 X（Twitter）登录",
  signInWithDiscord: "使用 Discord 登录",
  closeError: "关闭错误提示",
  signingIn: "正在登录...",
  authFailed: "认证失败，请重试。",
};
